import i18next from "i18next"
import { initReactI18next } from "react-i18next"
/* import translationDutch from "./translation/dutch/translation.json" */
/* import translationCzech from "./translation/czech/translation.json" */
import translationEnglish from "./translation/english/translation.json"
import translationFrench from "./translation/french/translation.json"
import translationGerman from "./translation/german/translation.json"
import translationGreek from "./translation/greek/translation.json"
import translationHungarian from "./translation/hungarian/translation.json"
import translationItalian from "./translation/italian/translation.json"
import translationLithuanian from "./translation/lithuanian/translation.json"
import translationPolish from "./translation/polish/translation.json"
import translationPortuguese from "./translation/portuguese/translation.json"
/* import translationSlovenian from "./translation/slovenian/translation.json" */
/* import translationSpanish from "./translation/spanish/translation.json" */
/* import translationSwedish from "./translation/swedish/translation.json" */
import translationUkrainian from "./translation/ukrainian/translation.json"

const resources = {
  /* CS: {
    translation: translationCzech
  }, */
  /* NL: {
    translation: translationDutch
  }, */
  EN: {
    translation: translationEnglish
  },
  FR: {
    translation: translationFrench
  },
  DE: {
    translation: translationGerman
  },
  EL: {
    translation: translationGreek
  },
  HU: {
    translation: translationHungarian
  },
  IT: {
    translation: translationItalian
  },
  LT: {
    translation: translationLithuanian
  },
  PL: {
    translation: translationPolish
  },
  PT: {
    translation: translationPortuguese
  },
  /*   SL: {
    translation: translationSlovenian
  },
  ES: {
    translation: translationSpanish
  }, */
  /* SV: {
    translation: translationSwedish
  }, */
  UK: {
    translation: translationUkrainian
  }
}

i18next.use(initReactI18next).init({
  resources,
  lng: "EN", //default language
  fallbackLng: "EN"
})

export default i18next
